import earnImg from '../assets/earn/NO1_2.png';

import earnImg8 from '../assets/earn/8.jpg';


import { BiDownArrowCircle } from "react-icons/bi";
import { GiCheckboxTree, GiChart } from "react-icons/gi";
import { MdHistory, MdPeople, MdSettings } from "react-icons/md";

import { Link } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { Alert, Snackbar } from '@mui/material';
import { useState } from 'react';
const products = [
    {
        id: 1,
        name: 'Database',
        href: '#',
        imageSrc: earnImg8,
        imageAlt: "..",
        tag: 'Βάση δεδομένων προγραμμάτων Διαλογής στην Πηγή',

    },

    {
        id: 2,
        name: 'Progress Info',
        href: '#',
        imageSrc: earnImg,
        imageAlt: "..",
        tag: 'Προοδευτικά στοιχεία συμμετοχών και ανακύκλωσης',

    },

    {
        id: 3,
        name: 'User Logs',
        href: '#',
        imageSrc: earnImg,
        imageAlt: "..",
        tag: 'Αρχεία δραστηριότητας και καταγραφή ενεργειών χρηστών',

    },

    {
        id: 4,
        name: 'Users',
        href: '#',
        imageSrc: earnImg,
        imageAlt: "..",
        tag: 'Διαχείριση χρηστών και δημιουργία νέων λογαριασμών',

    },

    {
        id: 5,
        name: 'Config',
        href: '#',
        imageSrc: earnImg,
        imageAlt: "..",
        tag: 'Ρυθμίσεις παραμέτρων κόστους αποκομιδής',

    },

]

export default function Panels() {
    const { user } = useAuth();
    const [showPermissionError, setShowPermissionError] = useState(false);
    const [permissionErrorMessage, setPermissionErrorMessage] = useState("");

    const hasDataTableViewPermission = () => {
        if (!user || !user.role) return false;
        return user.role === 'admin' || user.role === 'user3' || user.role === 'user1'; 
    };

    const hasProgressViewPermission = () => {
        if (!user || !user.role) return false;
        return user.role === 'admin' || user.role === 'user2' || user.role === 'user1';
    };

    const hasUserLogsPermission = () => {
        if (!user || !user.role) return false;
        return user.role === 'admin';
    };

    const hasUsersPermission = () => {
        if (!user || !user.role) return false;
        return user.role === 'admin';
    };

    const hasConfigPermission = () => {
        if (!user || !user.role) return false;
        return user.role === 'admin';
    };

    const showPermissionMessage = (message) => {
        setPermissionErrorMessage(message);
        setShowPermissionError(true);
        setTimeout(() => setShowPermissionError(false), 3000);
    };

    const handlePanelClick = (panelId, e) => {
        if (panelId === 0 && !hasDataTableViewPermission()) {
            e.preventDefault();
            showPermissionMessage("Δεν έχετε δικαίωμα πρόσβασης στη Βάση Δεδομένων.");
            return false;
        }
        if (panelId === 1 && !hasProgressViewPermission()) {
            e.preventDefault();
            showPermissionMessage("Δεν έχετε δικαίωμα πρόσβασης στα Στοιχεία.");
            return false;
        }
        if (panelId === 2 && !hasUserLogsPermission()) {
            e.preventDefault();
            showPermissionMessage("Δεν έχετε δικαίωμα πρόσβασης στα Αρχεία Χρηστών. Μόνο διαχειριστές επιτρέπονται.");
            return false;
        }
        if (panelId === 3 && !hasUsersPermission()) {
            e.preventDefault();
            showPermissionMessage("Δεν έχετε δικαίωμα πρόσβασης στη Διαχείριση Χρηστών. Μόνο διαχειριστές επιτρέπονται.");
            return false;
        }
        if (panelId === 4 && !hasConfigPermission()) {
            e.preventDefault();
            showPermissionMessage("Δεν έχετε δικαίωμα πρόσβασης στις Ρυθμίσεις. Μόνο διαχειριστές επιτρέπονται.");
            return false;
        }
        return true;
    };

    return (
        <div className="bg-white ">
            <div className="max-w-2xl px-10 py-5 mx-auto sm:py-5 sm:px-6 lg:max-w-7xl lg:px-8 ">

                <div className="grid mb-10 gap-x-6 gap-y-6 sm:grid-cols-2 lg:grid-cols-4 xl:gap-x-16">

                    {products.map((product, id) => {
                        const hasPermission = id === 0 ? hasDataTableViewPermission() : 
                                              id === 1 ? hasProgressViewPermission() : 
                                              id === 2 ? hasUserLogsPermission() :
                                              id === 3 ? hasUsersPermission() :
                                              id === 4 ? hasConfigPermission() :
                                              false;
                        
                        const getRoute = (index) => {
                            switch(index) {
                                case 0: return '/database';
                                case 1: return '/progress';
                                case 2: return '/user-logs';
                                case 3: return '/users';
                                case 4: return '/config';
                                default: return '/';
                            }
                        };

                        const getIcon = (index) => {
                            switch(index) {
                                case 0: return <GiCheckboxTree className='text-app_blue' size={250} />;
                                case 1: return <GiChart className='p-9 text-app_yellow' size={250} />;
                                case 2: return <MdHistory className='p-9 text-app_green' size={250} />;
                                case 3: return <MdPeople className='p-9 text-app_red' size={250} />;
                                case 4: return <MdSettings className='p-9 text-orange-500' size={250} />;
                                default: return <GiCheckboxTree className='text-app_blue' size={250} />;
                            }
                        };

                        const panelContent = (
                            <div className={`relative overflow-hidden duration-200 ease-out bg-white shadow-2xl rounded-[50px] group shadow-gray-500 ${hasPermission ? 'cursor-pointer hover:-translate-y-3' : 'cursor-not-allowed opacity-60'}`}>
                                <div className="rounded-md min-h-80 aspect-w-1 aspect-h-1 lg:h-100 lg:aspect-none">
                                    <div className='flex justify-center '>
                                        {getIcon(id)}
                                    </div>
                                </div>
                                <div className="p-3.5">
                                    <div className="flex justify-center text-2xl font-semibold text-center text-app_green_light">
                                        {product.name}
                                        {!hasPermission && <span className="ml-2 text-red-500">🔒</span>}
                                    </div>
                                </div>
                                <div className="flex justify-center mb-1 text-center">
                                    <p className="font-medium text-md ">{product.tag}</p>
                                </div>
                                <div className={`flex justify-center p-7 ${hasPermission ? 'hover:animate-spin' : ''}`}>
                                    <BiDownArrowCircle size={65} className="text-app_green_light"></BiDownArrowCircle>
                                </div>
                            </div>
                        );

                        return (
                            <div key={product.id} className='bg-gradient-to-r from-app_green to-app_blue rounded-[50px] lg:max-w-xl pb-[10px] mt-5 md:mt-0'>
                                {hasPermission ? (
                                    <Link to={getRoute(id)}>
                                        {panelContent}
                                    </Link>
                                ) : (
                                    <div onClick={(e) => handlePanelClick(id, e)}>
                                        {panelContent}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* Permission Error Snackbar */}
            <Snackbar
                open={showPermissionError}
                autoHideDuration={3000}
                onClose={() => setShowPermissionError(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert 
                    onClose={() => setShowPermissionError(false)} 
                    severity="error" 
                    sx={{ width: '100%' }}
                >
                    {permissionErrorMessage}
                </Alert>
            </Snackbar>
        </div>
    )
}